import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/turfs')({
  component: () => <Outlet />,
})
